import { UserAuditLogEntry } from 'apis/auditLogs';

import { LineItems } from './lineItems';
import { SummaryItems } from './summaryItems';
import { UserActivityCard } from './userActivityCard';
import { statusColors } from './userActivityTypes.utils';

type ReturnRequestedProps = {
  entry: UserAuditLogEntry<'COMMERCE_RETURN_REQUESTED'>;
};

export const ReturnRequested = ({
  entry,
}: ReturnRequestedProps): JSX.Element => (
  <UserActivityCard
    entry={entry}
    icon="undo"
    color={statusColors.warning}
    title="Return requested"
    summary={
      <SummaryItems
        items={[
          { key: 'order', content: entry.order_id, copyText: entry.order_id },
          {
            key: 'return',
            content: entry.return_id,
            copyText: entry.return_id,
          },
          { key: 'reason', content: entry.reason },
        ]}
      />
    }
  >
    {entry.line_items?.length ? <LineItems items={entry.line_items} /> : null}
  </UserActivityCard>
);
